import { StyledTextArea } from './TextArea.styles';
import type { TextAreaProps } from './TextArea.types';

export function TextArea({ error, ...props }: TextAreaProps) {
  return <StyledTextArea aria-invalid={error || undefined} {...props} />;
}
